import { render } from "./agree-btn.vue?vue&type=template&id=5c15cb7b&scoped=true"
import script from "./agree-btn.vue?vue&type=script&lang=js"
export * from "./agree-btn.vue?vue&type=script&lang=js"

import "./agree-btn.vue?vue&type=style&index=0&id=5c15cb7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c15cb7b"]])

export default __exports__